export default import.meta.ROLLUP_FILE_URL_cP1PlwIRSln8iiklOw2aSQ;